import { createSlice } from '@reduxjs/toolkit';

const usageRecordFilterSlice = createSlice({
    name: 'usageRecordFilter',
    initialState: {
        isLoading: true,
        isError: false,
        error: false,
        getAllUsers: [],
    },
    reducers: {
        fetchAllUserOption: (state, action) => {
            state.getAllUsers = action.payload
            state.isLoading = false
        },
        fetchAllUserOptionError: (state, action) => {
            state.isLoading = false
            state.isError = true
            state.error = action?.payload?.response?.data?.message
        }
    },
});

export const { fetchAllUserOption, fetchAllUserOptionError } = usageRecordFilterSlice.actions;
export default usageRecordFilterSlice.reducer;